import { render } from "./Documentacion.vue?vue&type=template&id=307328ad&scoped=true"
import script from "./Documentacion.vue?vue&type=script&lang=js"
export * from "./Documentacion.vue?vue&type=script&lang=js"

import "./Documentacion.vue?vue&type=style&index=0&id=307328ad&scoped=true&lang=css"

import exportComponent from "/mnt/gasoil_files/gasoil/docker/boletiland/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-307328ad"]])

export default __exports__